export default "__VITE_ASSET__BqDdQjwT__"